<p>
  {{ settings.lang.pleaseWaitVerifyingDetails }}
</p>
